import { Typography, theme } from "antd";
import React, { useMemo } from "react";

/* ──────────────── parseFilterValues ──────────────── */

/**
 * 从 runResult 输出文本中提取指定指标的值
 * 匹配格式: "Label: value" 或 "Label = value"
 */
export const parseFilterValues = (
  output: string,
  items: string[],
): Record<string, string> => {
  if (!output || items.length === 0) return {};
  const values: Record<string, string> = {};
  items.forEach((item) => {
    const escaped = item.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(
      escaped + "\\s*[:=]\\s*([\\d]+(?:\\.[\\d]+)?\\s*%?)",
      "gi",
    );
    const matches = [...output.matchAll(regex)];
    if (matches.length > 0) {
      values[item] = matches[matches.length - 1][1];
    }
  });
  return values;
};

/* ──────────────── RtpMetricsPanel ──────────────── */

export const DEFAULT_METRIC_KEYS = [
  "Free Spin Win Rate",
  "Total RTP",
  "Base RTP",
  "Free RTP",
];

interface RtpMetricsPanelProps {
  /** runResult 输出文本 */
  runResult?: string;
  /** 要提取的指标名称列表 */
  metricKeys?: string[];
}

const RtpMetricsPanel: React.FC<RtpMetricsPanelProps> = ({
  runResult,
  metricKeys = DEFAULT_METRIC_KEYS,
}) => {
  const { token } = theme.useToken();

  const values = useMemo(() => {
    if (!runResult) return {};
    return parseFilterValues(runResult, metricKeys);
  }, [runResult, metricKeys]);

  if (metricKeys.length === 0) return null;

  return (
    <div style={{ display: "flex", gap: 8 }}>
      {metricKeys.map((key) => (
        <div
          key={key}
          style={{
            flex: 1,
            padding: "8px 12px",
            background: token.colorFillAlter,
            border: `1px solid ${token.colorBorderSecondary}`,
            borderRadius: token.borderRadius,
            textAlign: "center",
            overflow: "hidden",
          }}
        >
          <Typography.Text
            type="secondary"
            style={{
              fontSize: 12,
              display: "block",
              marginBottom: 4,
              whiteSpace: "nowrap",
            }}
            ellipsis={{ tooltip: key }}
          >
            {key}
          </Typography.Text>
          <Typography.Text strong style={{ fontSize: 16 }}>
            {values[key] || "—"}
          </Typography.Text>
        </div>
      ))}
    </div>
  );
};

export default RtpMetricsPanel;
